import React, {useState} from "react"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import { siteUrl } from "../../../shared/utils/siteUrl"
import WriteForUs from "../../atoms/write-for-us/write-for-us"
import FormCreate from "../../molecules/form-create/form-create"
import HeaderCreateContent from "../../molecules/header-create-content/header-create-content"
import StepsCreateArticles from "../../molecules/steps-create-articles/steps-create-articles"
import "./content-create.scss"

const ContentCreate = props => {
  const { mobile, setModalActive, steps } = props
  const [isLoving, setIsLoving] = useState(true)
  const homeLink = siteUrl + "/"

  return (
    <div className="f-create-content">
      <div className="f-breadcrum-position">
        <Breadcrumb mobile={mobile} />
      </div>
      {/* <HeaderCreateContent mobile={mobile} /> */}
      <div className={"f-create-container"}>
        {
          !isLoving
          ?
            <>
              <a href={homeLink + "magazin/nuestro-mundo/"}>
                <span className="f-backbutton-article">
                  <span className="f-icon icon-left f-icon-back"></span>
                  <div className="f-text-decoration">
                    <span className="f-regular">Volver a</span>
                    <span className="f-bold">MAGAZÍN</span>
                  </div>
                </span>
              </a>
              <WriteForUs />
            </>
          : null
        }
        <FormCreate mobile={mobile} setModalActive={setModalActive} />
      </div>
      {/* <StepsCreateArticles
        steps={steps}
        mobile={mobile}
        setModalActive={setModalActive}
      /> */}
    </div>
  )
}

export default ContentCreate
